export default __webpack_public_path__ + "static/undppa-logo-2fcfe1f134de253165547f1fe5784975.png";